import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import { IAuthorization, IDbTask, IUserLogGroup } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { CtrlParamsEditorComponent } from "fwork.react.test/src/components/ctrlParams/editor"
import { FilterQuery } from 'mongoose'
import { useSnackbar } from "notistack"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { AuthorizationsApiClient } from "../../apiClient/authorizations"
import { TasksApiClient } from "../../apiClient/tasks"
import { UsersLogsGroupsApiClient } from '../../apiClient/usersLogsGroups'
import { DEFAULTGAP, RoutesNames } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"
import { DropDownSearchComponent } from '../common/dropDownSearch'
import axios from '../../apiClient/axios'

export const DbTaskComponent = (props: {
  id?: number
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [authorizations, setAuthorizations] = useState<IAuthorization[] | undefined>()
  const [logsGroups, setLogsGroups] = useState<IAuthorization[] | undefined>()

  const [task, setTask] = useState<IDbTask | undefined>({
    _id: null,
    id: 0,
    name: "",
    screen_ctrols: [],
    script_sql: "",
    active: true
  })

  React.useEffect(() => {
    getAuthorizations()
    getLogGroups()

    if (props.id)
      getData(props.id)
  }, [])

  let gettingData = false
  const getData = async (id: number) => {
    if (gettingData) return
    gettingData = true

    try {
      const response = await new TasksApiClient(axios).get({
        where: {
          id
        },
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        const responseTmp = response.data.payload[0]
        setTask(responseTmp)
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      gettingData = false
    }
  }

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (!task) return
    if (saving) return
    setSaving(true)
    try {
      const response = task.id ?
        await new TasksApiClient(axios).put({
          data: task
        }) : await new TasksApiClient(axios).post({
          data: task
        })

      if (response.success == true) {
        enqueueSnackbar(ApiClientUtils.getErrorMessage('Operação realizada com sucesso'), { variant: 'success' })
        navigate(`${RoutesNames.tasks}?refresh=true`)
      } else {
        enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  const [gettingAuthorizations, setGettingAuthorizations] = useState<boolean>(false)
  const getAuthorizations = async (where?: FilterQuery<IAuthorization> | undefined) => {
    if (gettingAuthorizations) return
    setGettingAuthorizations(true)

    try {
      const response = await new AuthorizationsApiClient(axios).get({
        where,
        sort: { name: 1 }
      })

      if (response.success) {
        setAuthorizations(response.data?.payload)
        return response.data?.payload
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingAuthorizations(false)
    }
  }

  const [gettingLogGroups, setGettingLogGroups] = useState<boolean>(false)
  const getLogGroups = async (where?: FilterQuery<IUserLogGroup> | undefined) => {
    if (gettingLogGroups) return
    setGettingLogGroups(true)

    try {
      const response = await new UsersLogsGroupsApiClient(axios).get({
        where,
        sort: { name: 1 }
      })

      if (response.success) {
        setLogsGroups(response.data?.payload)
        return response.data?.payload
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingLogGroups(false)
    }
  }

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField value={task?.name || ''} fullWidth label={'Nome da Tarefa'} onChange={(e) => {
          setTask(prev => {
            return {
              ...prev,
              name: e.target.value
            } as IDbTask
          })
        }} />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP}>
        <DropDownSearchComponent
          initInputValue={authorizations?.filter(a => a.id == task?.auth_id)[0]?.name || ''}
          progress={gettingAuthorizations}
          label="Autorização"
          modelLabelName="name"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getAuthorizations({
                name: { $regex: typedText, $options: 'i' }
              })
          }}
          onSelectItem={(item: IAuthorization) => {
            setTask(prev => {
              return {
                ...prev,
                auth_id: item.id
              } as IDbTask
            })
          }}
          onClear={() => setTask(prev => {
            return {
              ...prev,
              auth_id: Number(undefined)
            } as IDbTask
          })}
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP}>
        <DropDownSearchComponent
          initInputValue={logsGroups?.filter(a => a.id == task?.log_group_id)[0]?.name || ''}
          progress={gettingLogGroups}
          label="Classificação de Logs"
          modelLabelName="name"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getLogGroups({
                name: { $regex: typedText, $options: 'i' }
              })
          }}
          onSelectItem={(item: IUserLogGroup) => {
            setTask(prev => {
              return {
                ...prev,
                log_group_id: item.id
              } as IDbTask
            })
          }}
          onClear={() => setTask(prev => {
            return {
              ...prev,
              log_group_id: Number(undefined)
            } as IDbTask
          })}
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <TextField multiline maxRows={15} value={task?.script_sql || ''} fullWidth label={'Script'} onChange={(e) => {
          setTask(prev => {
            return {
              ...prev,
              script_sql: e.target.value
            } as IDbTask
          })
        }} />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <FormControlLabel
          control={
            <Checkbox
              checked={task?.active ? true : false}
              onChange={e => {
                setTask(prev => {
                  return {
                    ...prev,
                    active: e.target.checked
                  } as IDbTask
                })
              }} />
          }
          label='Ativar execução da tarefa' />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <h3 style={{ margin: 0 }}>Abaixo, defina os controles de formulário para o usuário digitar os valores dos parametros</h3>
        <div>Para cada parametro definido no script deve-se escolher um controle de input correspondente</div>
        <CtrlParamsEditorComponent ctrls={task?.screen_ctrols || []} style={{ width: '100%', border: '1px solid #C4C4C4', borderRadius: 5 }} onChangeCtrols={(ctrls) => {
          setTask(prev => {
            return {
              ...prev,
              screen_ctrols: ctrls
            } as IDbTask
          })
        }} />
      </FormItemStyled>
    </FormStyled>

    <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={() => save()} />
  </>
}